import React from "react";
import { Link, useLocation } from "react-router-dom";
import { JNTUK_PDF_Links } from "../../../utils/api.config";
import { imageBaseURL } from "../../../utils/fetchData";
import naaclogo from "../../../assets/img/logo/naac-logo.png";

import menuImg1 from "../../../assets/img/menu/1.png";
import menuImg2 from "../../../assets/img/menu/2.png";
import menuImg3 from "../../../assets/img/menu/3.png";
import menuImg5 from "../../../assets/img/menu/5.png";
import menuImg6 from "../../../assets/img/menu/6.png";
import menuImg7 from "../../../assets/img/menu/7.png";

const MenuItems = (props) => {
  const { parentMenu, secondParentMenu } = props;

  const location = useLocation();
  const externalLink = (url) => {
    const userConfirmed = window.confirm(
      "You are being redirected to an external website. Please note that JNTUK Portal is not responsible for external websites content & privacy policies."
    );

    if (userConfirmed) {
      window.open(url, "_blank");
    } else {
    }
  };
  const subDomain = (url) => {
    // const userConfirmed = window.confirm(
    //   "You are being redirected to an internal sub-domain website. The sub-domain website will open in a New Tab"
    // );

    // if (userConfirmed) {
    window.open(url, "_blank");
    // } else {

    // }
  };
  return (
    <React.Fragment>
      <li className="rs-mega-menu menu-item-has-children submenuLeftAligned">
        <Link
          to={{ pathname: `${process.env.REACT_APP_JNTUK_BASE_URL}/about` }}
          target="_blank"
        >
          About
        </Link>
        <ul className="mega-menu">
          <li className="mega-menu-container">
            <div className="single-megamenu">
              <ul className="sub-menu">
                <li>
                  <Link
                    to={{
                      pathname: `${process.env.REACT_APP_JNTUK_BASE_URL}/about`,
                    }}
                    target="_blank"
                  >
                    About JNTUK
                  </Link>
                </li>
              </ul>
              <ul className="sub-menu">
                <li>
                  <Link
                    to={{
                      pathname: `${process.env.REACT_APP_JNTUK_BASE_URL}/jntukvision
`,
                    }}
                    target="_blank"
                  >
                    Governance, Leadership and Management
                  </Link>
                  <ul>
                    <li>
                      <Link
                        to={{
                          pathname: `${process.env.REACT_APP_JNTUK_BASE_URL}/jntukvision/institutional_vision_and_leadership
`,
                        }}
                        target="_blank"
                      >
                        Institutional Vision and Leadership
                      </Link>
                    </li>
                    <li>
                      <Link
                        to={{
                          pathname: `${process.env.REACT_APP_JNTUK_BASE_URL}/jntukvision/core_values`,
                        }}
                        target="_blank"
                      >
                        Core Values
                      </Link>
                    </li>
                    <li>
                      <Link
                        to={{
                          pathname: `${process.env.REACT_APP_JNTUK_BASE_URL}/jntukvision/institutional_values_and_best_practices`,
                        }}
                        target="_blank"
                      >
                        Institutional Values and Best Practices
                      </Link>
                    </li>
                  </ul>
                </li>
              </ul>
              <ul className="sub-menu">
                <li>
                  <Link
                    to={{
                      pathname: `${process.env.REACT_APP_JNTUK_BASE_URL}/SWOC`,
                    }}
                    target="_blank"
                  >
                    SWOC
                  </Link>
                  <ul>
                    <li>
                      <Link
                        to={{
                          pathname: `${process.env.REACT_APP_JNTUK_BASE_URL}/SWOC/institutional_strength`,
                        }}
                        target="_blank"
                      >
                        Institutional Strength
                      </Link>
                    </li>
                    <li>
                      <Link
                        to={{
                          pathname: `${process.env.REACT_APP_JNTUK_BASE_URL}/SWOC/institutional_weakness`,
                        }}
                        target="_blank"
                      >
                        Institutional Weakness
                      </Link>
                    </li>
                    <li>
                      <Link
                        to={{
                          pathname: `${process.env.REACT_APP_JNTUK_BASE_URL}/SWOC/institutional_opportunity`,
                        }}
                        target="_blank"
                      >
                        Institutional Opportunity
                      </Link>
                    </li>
                    <li>
                      <Link
                        to={{
                          pathname: `${process.env.REACT_APP_JNTUK_BASE_URL}/SWOC/institutional_challenge`,
                        }}
                        target="_blank"
                      >
                        Institutional Challenge
                      </Link>
                    </li>
                  </ul>
                </li>
              </ul>
            </div>
            <div className="single-megamenu">
              <ul className="sub-menu">
                <li>
                  <Link
                    to={{
                      pathname: `${process.env.REACT_APP_JNTUK_BASE_URL}/SDD`,
                    }}
                    target="_blank"
                  >
                    Strategy Development and Deployment
                  </Link>
                </li>
                <li>
                  <Link
                    to={{
                      pathname: `${process.env.REACT_APP_JNTUK_BASE_URL}/institutional-bodies`,
                    }}
                    target="_blank"
                  >
                    Institutional Bodies
                  </Link>
                </li>
                <li>
                  <a
                    href={`${imageBaseURL}${JNTUK_PDF_Links.JNTU_Act_Link}`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    JNTU Act
                  </a>
                </li>
                <li>
                  <a
                    href={`${imageBaseURL}${JNTUK_PDF_Links.RTI_Act_Link}`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    RTI Act
                  </a>
                </li>
                <li>
                  <Link
                    to={{
                      pathname: `${process.env.REACT_APP_JNTUK_BASE_URL}/university-song`,
                    }}
                    target="_blank"
                  >
                    University Song
                  </Link>
                </li>
                <li>
                  <Link
                    to={{
                      pathname: `${process.env.REACT_APP_JNTUK_BASE_URL}/category/Press-Releases`,
                    }}
                    target="_blank"
                  >
                    Media/Press
                  </Link>
                </li>
                <li>
                  <Link
                    to={{
                      pathname: `${process.env.REACT_APP_JNTUK_BASE_URL}/jntuk-contacts`,
                    }}
                    target="_blank"
                  >
                    Contacts
                  </Link>
                </li>
                <li>
                  <Link
                    to={{
                      pathname: `${process.env.REACT_APP_JNTUK_BASE_URL}/gallery`,
                    }}
                    target="_blank"
                  >
                    Univ Gallery
                  </Link>
                </li>
                <li>
                  <Link
                    to={{
                      pathname: `${process.env.REACT_APP_JNTUK_BASE_URL}/convocations`,
                    }}
                    target="_blank"
                  >
                    Convocations
                  </Link>
                </li>
                <li>
                  <Link
                    to={{
                      pathname: `${process.env.REACT_APP_JNTUK_BASE_URL}/category/Tie-ups-and-Mou’s`,
                    }}
                    target="_blank"
                  >
                    Tie Ups & MOU's
                  </Link>
                </li>
              </ul>
            </div>
            <div className="single-megamenu">
              <ul className="sub-menu">
                <li>
                  <Link
                    to={{
                      pathname: `${process.env.REACT_APP_JNTUK_BASE_URL}/governing-hierarchy`,
                    }}
                    target="_blank"
                  >
                    Governing Heirarchy
                  </Link>
                </li>
                <li>
                  <Link
                    to={{
                      pathname: `${process.env.REACT_APP_JNTUK_BASE_URL}/location-map`,
                    }}
                    target="_blank"
                  >
                    Location Map
                  </Link>
                </li>
              </ul>
            </div>
          </li>
        </ul>
      </li>
      <li className="rs-mega-menu menu-item-has-children">
        <Link
          to={{ pathname: `${process.env.REACT_APP_JNTUK_BASE_URL}` }}
          target="_blank"
        >
          Administration
        </Link>
        <ul className="mega-menu">
          <li className="mega-menu-container">
            <div className="single-megamenu">
              <ul className="sub-menu">
                <li>
                  <Link
                    to={{
                      pathname: `${process.env.REACT_APP_JNTUK_BASE_URL}/profile/chancellor`,
                    }}
                    target="_blank"
                  >
                    Chancellor
                  </Link>
                </li>
                <li>
                  <Link
                    to={{
                      pathname: `${process.env.REACT_APP_JNTUK_BASE_URL}/profile/vice-chancellor`,
                    }}
                    target="_blank"
                  >
                    Vice Chancellor
                  </Link>
                </li>
              </ul>
              <ul className="sub-menu">
                <li>
                  <Link
                    to={{
                      pathname: `${process.env.REACT_APP_JNTUK_BASE_URL}/profile/rector`,
                    }}
                    target="_blank"
                  >
                    Rector
                  </Link>
                </li>
                <li>
                  <Link
                    to={{
                      pathname: `${process.env.REACT_APP_JNTUK_BASE_URL}/profile/registrar`,
                    }}
                    target="_blank"
                  >
                    Registrar
                  </Link>
                </li>
                <li>
                  <Link
                    to={{
                      pathname: `${process.env.REACT_APP_JNTUK_BASE_URL}/profile/osd`,
                    }}
                    target="_blank"
                  >
                    OSD
                  </Link>
                </li>
              </ul>
              <ul className="sub-menu">
                <li>
                  <Link
                    to={{
                      pathname: `${process.env.REACT_APP_JNTUK_BASE_URL}/executive-council`,
                    }}
                    target="_blank"
                  >
                    Executive Council
                  </Link>
                </li>
                <li>
                  <Link
                    to={{
                      pathname: `${process.env.REACT_APP_JNTUK_BASE_URL}/academic-senate`,
                    }}
                    target="_blank"
                  >
                    Academic Senaate
                  </Link>
                </li>
                <li>
                  <Link
                    to={{
                      pathname: `${process.env.REACT_APP_JNTUK_BASE_URL}/board-of-studies`,
                    }}
                    target="_blank"
                  >
                    Board of Studies
                  </Link>
                </li>
              </ul>
            </div>
            <div className="single-megamenu">
              <ul className="sub-menu">
                <li>
                  <Link
                    to={{
                      pathname: `${process.env.REACT_APP_JNTUK_BASE_URL}/directorates`,
                    }}
                    target="_blank"
                  >
                    Directorates
                  </Link>
                  <ul>
                    <li>
                      <Link
                        to={{
                          pathname: `${process.env.REACT_APP_JNTUK_BASE_URL}/profile/academics-and-planning-dap`,
                        }}
                        target="_blank"
                      >
                        Director, Academic Planning
                      </Link>
                    </li>
                    <li>
                      <Link
                        to={{
                          pathname: `${process.env.REACT_APP_JNTUK_BASE_URL}/profile/director-academic-audit`,
                        }}
                        target="_blank"
                      >
                        Director, Academic Audit
                      </Link>
                    </li>
                    <li>
                      <Link
                        to={{
                          pathname: `${process.env.REACT_APP_JNTUK_BASE_URL}/profile/director-of-evaluation-de`,
                        }}
                        target="_blank"
                      >
                        Director of Evaluation
                      </Link>
                    </li>
                    <li>
                      <Link
                        to={{
                          pathname: `${process.env.REACT_APP_JNTUK_BASE_URL}/profile/admissions-da`,
                        }}
                        target="_blank"
                      >
                        Director, Admissions
                      </Link>
                    </li>
                    <li>
                      <Link
                        to={{
                          pathname: `${process.env.REACT_APP_JNTUK_BASE_URL}/profile/director-industry-institute-interaction-placements-and-training`,
                        }}
                        target="_blank"
                      >
                        Director, IIIP & Training
                      </Link>
                    </li>
                    <li>
                      <Link
                        to={{
                          pathname: `${process.env.REACT_APP_JNTUK_BASE_URL}/profile/director-research-and-development`,
                        }}
                        target="_blank"
                      >
                        Director, Research and Development
                      </Link>
                    </li>
                    <li>
                      <Link
                        to={{
                          pathname: `${process.env.REACT_APP_JNTUK_BASE_URL}/profile/faculty-development-centre`,
                        }}
                        target="_blank"
                      >
                        Director, Faculty Development Centre
                      </Link>
                    </li>
                    <li>
                      <Link
                        to={{
                          pathname: `${process.env.REACT_APP_JNTUK_BASE_URL}/profile/infrastructure-development`,
                        }}
                        target="_blank"
                      >
                        Chief Engineer & Director, Infrastructure
                      </Link>
                    </li>
                    <li>
                      <Link
                        to={{
                          pathname: `${process.env.REACT_APP_JNTUK_BASE_URL}/profile/director-foreign-university-relations-dfur`,
                        }}
                        target="_blank"
                      >
                        Director, Foreign University Relations
                      </Link>
                    </li>
                    <li>
                      <Link
                        to={{
                          pathname: `${process.env.REACT_APP_JNTUK_BASE_URL}/profile/institute-of-science-and-technology-ist`,
                        }}
                        target="_blank"
                      >
                        Director, IST
                      </Link>
                    </li>
                    <li>
                      <Link
                        to={{
                          pathname: `${process.env.REACT_APP_JNTUK_BASE_URL}/profile/school-of-management-studies`,
                        }}
                        target="_blank"
                      >
                        Director - School of Management Studies
                      </Link>
                    </li>
                    <li>
                      <Link
                        to={{
                          pathname: `${process.env.REACT_APP_JNTUK_BASE_URL}/profile/director-university-games-and-sports`,
                        }}
                        target="_blank"
                      >
                        Director(I/C) Director, University Games & Sports
                      </Link>
                    </li>
                    <li>
                      <Link
                        to={{
                          pathname: `${process.env.REACT_APP_JNTUK_BASE_URL}/profile/internal-quality-assurance-cell`,
                        }}
                        target="_blank"
                      >
                        Director, IQAC University Legal Cell
                      </Link>
                    </li>
                    <li>
                      <Link
                        to={{
                          pathname: `${process.env.REACT_APP_JNTUK_BASE_URL}/profile/director-empowerment-of-women-grievances`,
                        }}
                        target="_blank"
                      >
                        Director, Empowerment of Women & Grievances
                      </Link>
                    </li>
                    <li>
                      <Link
                        to={{
                          pathname: `${process.env.REACT_APP_JNTUK_BASE_URL}/profile/director-bics`,
                        }}
                        target="_blank"
                      >
                        Director, BICS
                      </Link>
                    </li>
                    <li>
                      <Link
                        to={{
                          pathname: `${process.env.REACT_APP_JNTUK_BASE_URL}/profile/director-libraryn`,
                        }}
                        target="_blank"
                      >
                        Director, ODL & OL Programmes
                      </Link>
                    </li>
                    <li>
                      <Link
                        to={{
                          pathname: `${process.env.REACT_APP_JNTUK_BASE_URL}/profile/director-green-campus-initiatives`,
                        }}
                        target="_blank"
                      >
                        Director, Green Campus Initiatives
                      </Link>
                    </li>
                    <li>
                      <Link
                        to={{
                          pathname: `${process.env.REACT_APP_JNTUK_BASE_URL}/profile/director-incubation`,
                        }}
                        target="_blank"
                      >
                        Director(I/C) Incubation
                      </Link>
                    </li>
                  </ul>
                </li>
              </ul>
            </div>
            <div className="single-megamenu">
              <ul className="sub-menu">
                <li>
                  <Link
                    to={{
                      pathname: `${process.env.REACT_APP_JNTUK_BASE_URL}/profile/chancellor`,
                    }}
                    target="_blank"
                  >
                    Principal's
                  </Link>
                  <ul>
                    <li>
                      <Link
                        to={{
                          pathname: `${process.env.REACT_APP_JNTUK_BASE_URL}/profile/principal-university-college-of-engineering-kakinada`,
                        }}
                        target="_blank"
                      >
                        Principal, UCEK
                      </Link>
                    </li>
                    <li>
                      <Link
                        to={{
                          pathname: `${process.env.REACT_APP_JNTUK_BASE_URL}/profile/principal-university-college-of-engineering-narasaraopeta`,
                        }}
                        target="_blank"
                      >
                        Principal, UCEN
                      </Link>
                    </li>
                  </ul>
                </li>
              </ul>
              <ul className="sub-menu">
                <li>
                  <Link
                    to={{
                      pathname: `${process.env.REACT_APP_JNTUK_BASE_URL}/special-officers`,
                    }}
                    target="_blank"
                  >
                    Special Officers
                  </Link>
                </li>
              </ul>
            </div>
          </li>
        </ul>
      </li>
      <li className="rs-mega-menu menu-item-has-children">
        <Link
          to={{ pathname: `${process.env.REACT_APP_JNTUK_BASE_URL}` }}
          target="_blank"
          as="#"
        >
          Academics
        </Link>
        <ul className="mega-menu">
          <li className="mega-menu-container">
            <div className="single-megamenu">
              <ul className="sub-menu">
                <li>
                  <Link
                    to={{
                      pathname: `${process.env.REACT_APP_JNTUK_BASE_URL}/methodology`,
                    }}
                    target="_blank"
                  >
                    Methodology
                  </Link>
                </li>
                <li>
                  <Link
                    to={{
                      pathname: `${process.env.REACT_APP_JNTUK_BASE_URL}/admissions`,
                    }}
                    target="_blank"
                  >
                    Admission
                  </Link>
                </li>
              </ul>
              <ul className="sub-menu">
                <li>
                  <Link
                    to={{
                      pathname: `${process.env.REACT_APP_JNTUK_BASE_URL}/under-graduate`,
                    }}
                    target="_blank"
                  >
                    UG - Programmes Offered - Affiliated
                  </Link>
                  <ul>
                    <li>
                      <Link
                        to={{
                          pathname: `${process.env.REACT_APP_JNTUK_BASE_URL}/course/1`,
                        }}
                        target="_blank"
                      >
                        Bachelor of Technology
                      </Link>
                    </li>
                    <li>
                      <Link
                        to={{
                          pathname: `${process.env.REACT_APP_JNTUK_BASE_URL}/course/2`,
                        }}
                        target="_blank"
                      >
                        Bachelor of Pharmacy
                      </Link>
                    </li>
                    <li>
                      <Link
                        to={{
                          pathname: `${process.env.REACT_APP_JNTUK_BASE_URL}/course/3`,
                        }}
                        target="_blank"
                      >
                        Bachelor of Architecture
                      </Link>
                    </li>
                  </ul>
                </li>
              </ul>
              <ul className="sub-menu">
                <li>
                  <Link
                    to={{
                      pathname: `${process.env.REACT_APP_JNTUK_BASE_URL}/post-graduate`,
                    }}
                    target="_blank"
                  >
                    PG - Programmers Offered - Affiliated
                  </Link>
                  <ul>
                    <li>
                      <Link
                        to={{
                          pathname: `${process.env.REACT_APP_JNTUK_BASE_URL}/course/4`,
                        }}
                        target="_blank"
                      >
                        Pharm D
                      </Link>
                    </li>
                    <li>
                      <Link
                        to={{
                          pathname: `${process.env.REACT_APP_JNTUK_BASE_URL}/course/5`,
                        }}
                        target="_blank"
                      >
                        Master of Technology
                      </Link>
                    </li>
                    <li>
                      <Link
                        to={{
                          pathname: `${process.env.REACT_APP_JNTUK_BASE_URL}/course/6`,
                        }}
                        target="_blank"
                      >
                        Master of Pharmacy
                      </Link>
                    </li>
                    <li>
                      <Link
                        to={{
                          pathname: `${process.env.REACT_APP_JNTUK_BASE_URL}/course/7`,
                        }}
                        target="_blank"
                      >
                        Master of Computer Applications
                      </Link>
                    </li>
                    <li>
                      <Link
                        to={{
                          pathname: `${process.env.REACT_APP_JNTUK_BASE_URL}/course/8`,
                        }}
                        target="_blank"
                      >
                        Master of Bussiness Administration
                      </Link>
                    </li>
                    <li>
                      <Link
                        to={{
                          pathname: `${process.env.REACT_APP_JNTUK_BASE_URL}/course/9`,
                        }}
                        target="_blank"
                      >
                        Management of Applied Management
                      </Link>
                    </li>
                  </ul>
                </li>
              </ul>
            </div>
            <div className="single-megamenu">
              <ul className="sub-menu">
                <li>
                  <Link
                    to={{
                      pathname: `${process.env.REACT_APP_JNTUK_BASE_URL}/phd-courses`,
                    }}
                    target="_blank"
                  >
                    Research
                  </Link>
                  <ul>
                    <li>
                      <Link
                        to={{
                          pathname: `${process.env.REACT_APP_JNTUK_BASE_URL}/phd-courses/Promotion_of_Research_and_Facilities`,
                        }}
                        target="_blank"
                      >
                        Promotion of Research and Facilities
                      </Link>
                    </li>
                    <li>
                      <Link
                        to={{
                          pathname: `${process.env.REACT_APP_JNTUK_BASE_URL}/phd-courses/Innovations_and_Extension`,
                        }}
                        target="_blank"
                      >
                        Innovations and Extension
                      </Link>
                    </li>
                    <li>
                      <Link
                        to={{
                          pathname: `${process.env.REACT_APP_JNTUK_BASE_URL}/phd-courses/Innovation_Ecosystem`,
                        }}
                        target="_blank"
                      >
                        Innovation Ecosystem{" "}
                      </Link>
                    </li>
                    <li>
                      <Link
                        to={{
                          pathname: `${process.env.REACT_APP_JNTUK_BASE_URL}/phd-courses/Research_Branches`,
                        }}
                        target="_blank"
                      >
                        Branches
                      </Link>
                    </li>
                    <li>
                      <Link
                        to={{
                          pathname: `${process.env.REACT_APP_JNTUK_BASE_URL}/phd-courses/Regulations_and_Guidelines`,
                        }}
                        target="_blank"
                      >
                        Regulations & Guidelines
                      </Link>
                    </li>
                  </ul>
                </li>
              </ul>
              <ul className="sub-menu">
                <li>
                  <Link
                    to={{
                      pathname: `${process.env.REACT_APP_JNTUK_BASE_URL}/category/Academic-Calendars`,
                    }}
                    target="_blank"
                  >
                    Academic Calendars
                  </Link>
                </li>
                <li>
                  <Link
                    to={{
                      pathname: `${process.env.REACT_APP_JNTUK_BASE_URL}/programmes-offered`,
                    }}
                    target="_blank"
                  >
                    Programmes Offered
                  </Link>
                </li>
              </ul>
              <ul className="sub-menu">
                <li>
                  <Link
                    to={{
                      pathname: `${process.env.REACT_APP_JNTUK_BASE_URL}/academicsdata`,
                    }}
                    target="_blank"
                  >
                    Circular Aspects
                  </Link>
                  <ul>
                    <li>
                      <Link
                        to={{
                          pathname: `${process.env.REACT_APP_JNTUK_BASE_URL}/academicsdata/Circular_Aspects`,
                        }}
                        target="_blank"
                      >
                        Circular Aspects
                      </Link>
                    </li>
                    <li>
                      <Link
                        to={{
                          pathname: `${process.env.REACT_APP_JNTUK_BASE_URL}/academicsdata/Curriculum_Design_and_Development`,
                        }}
                        target="_blank"
                      >
                        Curriculum Design and Development
                      </Link>
                    </li>
                    <li>
                      <Link
                        to={{
                          pathname: `${process.env.REACT_APP_JNTUK_BASE_URL}/academicsdata/Curriculum_Enrichment`,
                        }}
                        target="_blank"
                      >
                        Curriculum Enrichment
                      </Link>
                    </li>
                  </ul>
                </li>
              </ul>
            </div>
            <div className="single-megamenu">
              <ul className="sub-menu">
                <li>
                  <Link
                    to={{
                      pathname: `${process.env.REACT_APP_JNTUK_BASE_URL}/teachingLearnProcess`,
                    }}
                    target="_blank"
                  >
                    Teaching-Learning Process
                  </Link>
                </li>
                <li>
                  <Link
                    to={{
                      pathname: `${process.env.REACT_APP_JNTUK_BASE_URL}/studentsupportprogression`,
                    }}
                    target="_blank"
                  >
                    Student Support and Progression
                  </Link>
                </li>
              </ul>
              <ul className="sub-menu">
                <li>
                  <Link
                    to={{
                      pathname: `${process.env.REACT_APP_JNTUK_BASE_URL}/infrastructurelearning`,
                    }}
                    target="_blank"
                  >
                    Infrastructure and Learning Resources
                  </Link>
                  <ul>
                    <li>
                      <Link
                        to={{
                          pathname: `${process.env.REACT_APP_JNTUK_BASE_URL}/infrastructurelearning/physical_facilities`,
                        }}
                        target="_blank"
                      >
                        Physical Facilities
                      </Link>
                    </li>
                    <li>
                      <Link
                        to={{
                          pathname: `${process.env.REACT_APP_JNTUK_BASE_URL}/infrastructurelearning/adequate_facilities`,
                        }}
                        target="_blank"
                      >
                        Adequate Facilities
                      </Link>
                    </li>
                    <li>
                      <Link
                        to={{
                          pathname: `${process.env.REACT_APP_JNTUK_BASE_URL}/infrastructurelearning/learning_resource`,
                        }}
                        target="_blank"
                      >
                        Learning Resource
                      </Link>
                    </li>
                  </ul>
                </li>
              </ul>
              <ul className="sub-menu">
                <li>
                  <Link
                    to={{
                      pathname: `${process.env.REACT_APP_JNTUK_BASE_URL}#`,
                    }}
                    target="_blank"
                  >
                    Constituent Colleges/Units
                  </Link>
                  <ul>
                    <li>
                      <Link
                        onClick={() =>
                          externalLink("https://www.jntucek.ac.in")
                        }
                      >
                        University College of Engineering Kakinada Campus
                      </Link>
                    </li>
                    <li>
                      <Link
                        onClick={() => externalLink("https://jntukucen.ac.in")}
                      >
                        University College of Engineering Narasaraopet Campus
                      </Link>
                    </li>
                    <li>
                      <Link
                        onClick={() =>
                          subDomain(
                            `${process.env.REACT_APP_JNTUK_BASE_URL}/sms`
                          )
                        }
                      >
                        School of Management Studies
                      </Link>
                    </li>
                  </ul>
                </li>
              </ul>
            </div>
          </li>
        </ul>
      </li>
      <li className="rs-mega-menu menu-item-has-children">
        <Link
          to={{ pathname: `${process.env.REACT_APP_JNTUK_BASE_URL}#` }}
          target="_blank"
        >
          School Campus
        </Link>
        <ul className="mega-menu">
          <li className="mega-menu-container">
            <div className="single-megamenu">
              <ul className="sub-menu">
                <li>
                  <Link>INSTITUTE OF SCIENCE & TECHNOLOGY</Link>
                  <ul>
                    <li>
                      <Link
                        onClick={() =>
                          subDomain(
                            `${process.env.REACT_APP_JNTUK_BASE_URL}/shsr`
                          )
                        }
                      >
                        {" "}
                        School of Health Sciences and Research
                      </Link>
                    </li>
                    <li>
                      <Link
                        onClick={() =>
                          externalLink("https://jntukfoodtech.com")
                        }
                      >
                        {" "}
                        School of Food Technology
                      </Link>
                    </li>
                    <li>
                      <Link
                        onClick={() =>
                          subDomain(
                            `${process.env.REACT_APP_JNTUK_BASE_URL}/sree`
                          )
                        }
                      >
                        School of Renewable Energy & Environment
                      </Link>
                    </li>
                    <li>
                      <Link
                        onClick={() => externalLink("https://jntukbiotech.com")}
                      >
                        {" "}
                        School of Biotechnology{" "}
                      </Link>
                    </li>
                    <li>
                      <Link
                        onClick={() =>
                          subDomain(
                            `${process.env.REACT_APP_JNTUK_BASE_URL}/soa`
                          )
                        }
                      >
                        School of Avionics{" "}
                      </Link>
                    </li>
                    <li>
                      <Link
                        onClick={() =>
                          subDomain(
                            `${process.env.REACT_APP_JNTUK_BASE_URL}/ssit`
                          )
                        }
                      >
                        School of Spatial Information Technology
                      </Link>
                    </li>
                    <li>
                      <Link
                        onClick={() => subDomain(`${process.env.REACT_APP_JNTUK_BASE_URL}/sopst`)}
                      >
                        School of Pharmaceutical Sciences & Technologies
                      </Link>
                    </li>
                    <li>
                      <Link
                        onClick={() =>
                          subDomain(
                            `${process.env.REACT_APP_JNTUK_BASE_URL}/snt`
                          )
                        }
                      >
                        {" "}
                        School of Nano Technology
                      </Link>
                    </li>
                  </ul>
                </li>
              </ul>
            </div>
            <div className="single-megamenu col">
              <div className="menuImg">
                <div>
                  <img
                    src={menuImg1}
                    alt="School of Health Sciences And Research"
                    title="School of Health Sciences And Research"
                  />
                  <p>School of Health Sciences And Research</p>
                </div>
                <div>
                  <img
                    src={menuImg2}
                    alt="School Of Food Technology"
                    title="School Of Food Technology"
                  />
                  <p>School Of Food Technology</p>
                </div>
                <div>
                  <img
                    src={menuImg3}
                    alt="School Of Renewable Energy & Environment"
                    title="School Of Renewable Energy & Environment"
                  />
                  <p>School Of Renewable Energy & Environment</p>
                </div>
                <div>
                  <img
                    src={menuImg2}
                    alt="School Of Biotechnology"
                    title="School Of Biotechnology"
                  />
                  <p>School Of Biotechnology</p>
                </div>
                <div>
                  <img
                    src={menuImg5}
                    alt="School Of Avionics"
                    title="School Of Avionics"
                  />
                  <p>School Of Avionics</p>
                </div>
                <div>
                  <img
                    src={menuImg6}
                    alt="School Of Spatial Information Technolgy"
                    title="School Of Spatial Information Technolgy"
                  />
                  <p>School Of Spatial Information Technolgy</p>
                </div>
                <div>
                  <img
                    src={menuImg2}
                    alt="School Of Pharmaceutical Sciences & Technologies"
                    title="School Of Pharmaceutical Sciences & Technologies"
                  />
                  <p>School Of Pharmaceutical Sciences & Technologies</p>
                </div>
                <div>
                  <img
                    src={menuImg1}
                    alt="School Of Nano Technolgy"
                    title="School Of Nano Technolgy"
                  />
                  <p>School Of Nano Technolgy</p>
                </div>
              </div>
            </div>
          </li>
        </ul>
      </li>
      <li className="rs-mega-menu menu-item-has-children">
        <Link
          to={{ pathname: `${process.env.REACT_APP_JNTUK_BASE_URL}#` }}
          target="_blank"
          as="#"
        >
          Examinations
        </Link>
        <ul className="mega-menu">
          <li className="mega-menu-container">
            <div className="single-megamenu">
              <ul className="sub-menu">
                <li>
                  <Link
                    to={{
                      pathname: `${process.env.REACT_APP_JNTUK_BASE_URL}#`,
                    }}
                    target="_blank"
                  >
                    EXAMINATIONS
                  </Link>
                  <ul>
                    <li>
                      <Link
                        to={{
                          pathname: `${process.env.REACT_APP_JNTUK_BASE_URL}/profile/director-of-evaluation-de`,
                        }}
                        target="_blank"
                      >
                        Director of Evaluation
                      </Link>
                    </li>
                    <li>
                      <Link
                        to={{
                          pathname: `${process.env.REACT_APP_JNTUK_BASE_URL}/controller-of-examination-ug`,
                        }}
                        target="_blank"
                      >
                        Controller of Examinations (UG)
                      </Link>
                    </li>
                    <li>
                      <Link
                        to={{
                          pathname: `${process.env.REACT_APP_JNTUK_BASE_URL}/controller-of-examinations-pg-sdc`,
                        }}
                        target="_blank"
                      >
                        Controller of Examinations (PG and SDC)
                      </Link>
                    </li>
                    <li>
                      <Link
                        to={{
                          pathname: `${process.env.REACT_APP_JNTUK_BASE_URL}/addl-controller-of-examinations`,
                        }}
                        target="_blank"
                      >
                        Addl. Controller of Examinations
                      </Link>
                    </li>
                    <li>
                      <Link
                        to={{
                          pathname: `${process.env.REACT_APP_JNTUK_BASE_URL}/category/Academic Calendars`,
                        }}
                        target="_blank"
                      >
                        Academic Calendars
                      </Link>
                    </li>
                  </ul>
                </li>
              </ul>
              <ul className="sub-menu">
                <li>
                  <Link
                    to={{
                      pathname: `${process.env.REACT_APP_JNTUK_BASE_URL}/university-examination-fee-structure-of-various-courses`,
                    }}
                    target="_blank"
                  >
                    UNIVERSITY EXAMINATION FEE STRUCTURE
                  </Link>
                </li>
                <li>
                  <a
                    href={`${imageBaseURL}${JNTUK_PDF_Links.JNTUK_MALPRACTICE_GUIDELINES}`}
                    target="_blank"
                    rel="noreferrer"
                  >
                    JNTUK MALPRACTICE GUIDELINES
                  </a>
                </li>
              </ul>
            </div>
            <div className="single-megamenu ">
              <ul className="sub-menu">
                <li>
                  <a
                    href={`${imageBaseURL}${JNTUK_PDF_Links.PHD_AWARDEES_LIST_2016_2019}`}
                    target="_blank"
                    rel="noreferrer"
                  >
                    PH.D AWARDEES LIST 2016-2019
                  </a>
                </li>
                <li>
                  <a
                    href="https://jntukresults.edu.in/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    RESULTS PORTAL
                  </a>
                </li>
              </ul>
              <ul className="sub-menu">
                <li>
                  <Link
                    to={{
                      pathname: `${process.env.REACT_APP_JNTUK_BASE_URL}#`,
                    }}
                    target="_blank"
                  >
                    AFFILIATED COLLEGES
                  </Link>
                  <ul>
                    <li>
                      <Link
                        to={{
                          pathname: `${process.env.REACT_APP_JNTUK_BASE_URL}/affiliated-colleges-east-godavari`,
                        }}
                        target="_blank"
                      >
                        Affiliated Colleges – East Godavari
                      </Link>
                    </li>
                    <li>
                      <Link
                        to={{
                          pathname: `${process.env.REACT_APP_JNTUK_BASE_URL}/affiliated-colleges-west-godavari`,
                        }}
                        target="_blank"
                      >
                        Affiliated Colleges – West Godavari
                      </Link>
                    </li>
                    <li>
                      <Link
                        to={{
                          pathname: `${process.env.REACT_APP_JNTUK_BASE_URL}/affiliated-colleges-krishna`,
                        }}
                        target="_blank"
                      >
                        Affiliated Colleges – Krishna
                      </Link>
                    </li>
                    <li>
                      <Link
                        to={{
                          pathname: `${process.env.REACT_APP_JNTUK_BASE_URL}/affiliated-colleges-guntur`,
                        }}
                        target="_blank"
                      >
                        {" "}
                        Affiliated Colleges – Guntur
                      </Link>
                    </li>
                    <li>
                      <Link
                        to={{
                          pathname: `${process.env.REACT_APP_JNTUK_BASE_URL}/affiliated-colleges-prakasam`,
                        }}
                        target="_blank"
                      >
                        {" "}
                        Affiliated Colleges – Prakasam
                      </Link>
                    </li>
                  </ul>
                </li>
              </ul>
              <ul className="sub-menu">
                <li>
                  <Link
                    to={{
                      pathname: `${process.env.REACT_APP_JNTUK_BASE_URL}/autonomous-colleges`,
                    }}
                    target="_blank"
                  >
                    LIST OF AUTONOMOUS COLLEGES
                  </Link>
                </li>
              </ul>
            </div>
            <div className="single-megamenu">
              <ul className="sub-menu">
                <li>
                  <Link
                    to={{
                      pathname: `${process.env.REACT_APP_JNTUK_BASE_URL}#`,
                    }}
                    target="_blank"
                  >
                    DOWNLOADS
                  </Link>
                  <ul>
                    <li>
                      <Link
                        to={{
                          pathname: `${process.env.REACT_APP_JNTUK_BASE_URL}/category/Academic-Syllabus`,
                        }}
                        target="_blank"
                      >
                        Syllabus
                      </Link>
                    </li>
                    <li>
                      <a
                        href={`${imageBaseURL}${JNTUK_PDF_Links["2F_of_UGC"]}`}
                        target="_blank"
                        rel="noreferrer"
                      >
                        2F of UGC
                      </a>
                    </li>
                    <li>
                      <a
                        href={`${imageBaseURL}${JNTUK_PDF_Links["12B_of_UGC"]}`}
                        target="_blank"
                        rel="noreferrer"
                      >
                        12B of UGC
                      </a>
                    </li>
                    <li>
                      <a
                        href={`${imageBaseURL}${JNTUK_PDF_Links.IT_Policies}`}
                        target="_blank"
                        rel="noreferrer"
                      >
                        IT Policies
                      </a>
                    </li>
                  </ul>
                </li>
              </ul>
            </div>
          </li>
        </ul>
      </li>
      <li className="rs-mega-menu menu-item-has-children submenuRightAligned">
        <Link
          to={{ pathname: `${process.env.REACT_APP_JNTUK_BASE_URL}#` }}
          target="_blank"
        >
          Accreditations
        </Link>
        <ul className="mega-menu">
          <li className="mega-menu-container">
            <div className="single-megamenu">
              <ul className="sub-menu">
                <li>
                  <Link onClick={() => externalLink("https://jntukiqac.com")}>
                    ABOUT NIRF
                  </Link>
                  <ul>
                    <li>
                      <Link
                        onClick={() => externalLink("https://jntukiqac.com")}
                      >
                        MINUTES & MEETING
                      </Link>
                    </li>
                    <li>
                      <Link
                        onClick={() => externalLink("https://jntukiqac.com")}
                      >
                        COURSE-DETAILS
                      </Link>
                    </li>
                    <li>
                      <Link
                        onClick={() => externalLink("https://jntukiqac.com")}
                      >
                        NAAC DATA FILES
                      </Link>
                    </li>
                    <li>
                      <Link
                        onClick={() => externalLink("https://jntukiqac.com")}
                      >
                        PROGRAMME OFFERED
                      </Link>
                    </li>
                  </ul>
                </li>
              </ul>
              <ul className="sub-menu">
                <li>
                  <Link
                    to={{
                      pathname: `${process.env.REACT_APP_JNTUK_BASE_URL}#`,
                    }}
                    target="_blank"
                  >
                    FEEDBACK FORMS
                  </Link>
                  <ul>
                    <li>
                      <Link
                        to={{
                          pathname: `${process.env.REACT_APP_JNTUK_BASE_URL}`,
                        }}
                        target="_blank"
                      >
                        Alumini
                      </Link>
                    </li>
                    <li>
                      <Link
                        to={{
                          pathname: `${process.env.REACT_APP_JNTUK_BASE_URL}`,
                        }}
                        target="_blank"
                      >
                        Faculty
                      </Link>
                    </li>
                    <li>
                      <Link
                        to={{
                          pathname: `${process.env.REACT_APP_JNTUK_BASE_URL}`,
                        }}
                        target="_blank"
                      >
                        Industry
                      </Link>
                    </li>
                    <li>
                      <Link
                        to={{
                          pathname: `${process.env.REACT_APP_JNTUK_BASE_URL}`,
                        }}
                        target="_blank"
                      >
                        Student
                      </Link>
                    </li>
                  </ul>
                </li>
              </ul>
            </div>
            <div className="single-megamenu">
              <ul className="sub-menu">
                <li>
                  <Link
                    to={{
                      pathname: `${process.env.REACT_APP_JNTUK_BASE_URL}#`,
                    }}
                    target="_blank"
                  >
                    ACCREDITATIONS
                  </Link>
                  <ul>
                    <li>
                      <Link
                        to={{
                          pathname: `${process.env.REACT_APP_JNTUK_BASE_URL}/naac-reports`,
                        }}
                        target="_blank"
                      >
                        NAAC Reports
                      </Link>
                    </li>
                    <li>
                      <a
                        href={`${imageBaseURL}${JNTUK_PDF_Links.JNTUK_NAAC_SSR_2023}`}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        JNTUK NAAC SSR 2023
                      </a>
                    </li>
                    <li>
                      <a
                        href={`${imageBaseURL}${JNTUK_PDF_Links.NIRF_Overall_Report_2023}`}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        NIRF Overall Report -2023
                      </a>
                    </li>
                    <li>
                      <a
                        href={`${imageBaseURL}${JNTUK_PDF_Links.JNTUK_AQAR_2017_18}`}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {" "}
                        JNTUK AQAR 2017-18
                      </a>
                    </li>
                    <li>
                      <a
                        href={`${imageBaseURL}${JNTUK_PDF_Links.NIRF_Overall_Report_2022}`}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {" "}
                        NIRF Overall Report -2022
                      </a>
                    </li>
                    <li>
                      <a
                        href={`${imageBaseURL}${JNTUK_PDF_Links.NAAC_Self_Study_Report_Feb_2017}`}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        NAAC Self Study Report (SSR) - Feb 2017
                      </a>
                    </li>
                    <li>
                      <a
                        href={`${imageBaseURL}${JNTUK_PDF_Links.Annual_Quality_Assurance_Reports}`}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Annual Quality Assurance Reports(AQAR)
                      </a>
                    </li>
                    <li>
                      <a
                        href={`${imageBaseURL}${JNTUK_PDF_Links.ARAQ_Of_Student_Satisfaction_Survey}`}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Analysis Report and Questionnaire of Student
                        Satisfaction Survey
                      </a>
                    </li>
                    <li>
                      <a
                        href={`${imageBaseURL}${JNTUK_PDF_Links.National_Institutional_Rankings_Framework_2020}`}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        National Institutional Rankings Framework (NIRF) – 2020
                      </a>
                    </li>
                  </ul>
                </li>
              </ul>
            </div>
            <div className="single-megamenu align-self-end">
              <img src={naaclogo} alt="NAAC Logo" title="NAAC Logo" />
            </div>
          </li>
        </ul>
      </li>
    </React.Fragment>
  );
};

export default MenuItems;
